const apiHeaders = (context) => {
  const token = context.hasOwnProperty("$store")
    ? `Bearer ${context.$store.state.token}`
    : `Bearer ${context.state.token}`

  return {
    "Content-Type": "application/json",
    authorization: token,
    Accept: "application/json",
  }
}

export default (context) => ({
  httpCreateIpg(payload) {
    return context.$http.post(
      `${context.$store.getters.apiUrlParam}/ipg/store`,
      payload,
      {
        headers: apiHeaders(context),
      }
    )
  },
  httpUpdateIpg(payload) {
    return context.$http.post(
      `${context.$store.getters.apiUrlParam}/ipg/update`,
      payload,
      {
        headers: apiHeaders(context),
      }
    )
  },
  httpGetIpgShow() {
    return context.$http.get(
      `${context.$store.getters.apiWithVersionParam("3")}/ipg/show`,
      {
        headers: apiHeaders(context),
      }
    )
  },
  httpGetIpgShowAxios(axios) {
    return axios.get(`${context.getters.apiWithVersionParam("3")}/ipg/show`, {
      headers: apiHeaders(context),
    })
  },
})
